module.exports = __webpack_public_path__ + "img/joinUs_3.225af381.png";